import React from "react";
import "./imagePreviewModal.css";

const ImagePreviewModal = ({ open, src, onClose }) => {
  if (!open) return null;

  return (
    <div className="img-modal-overlay" onClick={onClose}>
      <div className="img-modal-content" onClick={(e) => e.stopPropagation()}>
        <img src={src} alt="preview" className="img-modal-image" />
        <button className="img-modal-close" onClick={onClose}>
          X
        </button>
      </div>
    </div>
  );
};

export default ImagePreviewModal;